import { forwardRef } from "react";
import { MaterialDesignContent, closeSnackbar } from "notistack";
import "./index.scss";

export const SnackbarNotification = forwardRef(
  ({ children, variant, closeButton = true, ...props }, ref) => {
    return (
      <MaterialDesignContent
        {...props}
        className="custom-snackbar-notification"
        variant={variant}
        action={(snackbarId) =>
          closeButton && (
            <button
              className="close-button"
              onClick={() => closeSnackbar(snackbarId)}
            >
              &#215;
            </button>
          )
        }
        ref={ref}
      >
        {children}
      </MaterialDesignContent>
    );
  }
);
